import React, {PureComponent, PropTypes} from 'react';
import cx from 'classnames';
import Moment from 'moment';
import {extendMoment} from 'moment-range';
import axios from 'axios';
import tippy from 'tippy.js';

Moment.locale('lv');
const moment = extendMoment(Moment);

import style from './calendar.module.css';

import leftArrow from './assets/left_arrow.png';
import rightArrow from './assets/right_arrow.png';

class Calendar extends PureComponent {

    constructor() {
        super();

        this.todayMoment = moment();
        this.currentMoment = moment();

        this.state = this.calculateState();
    }

    calculateState() {
        const rangeData = this.calculateRange();

        return {
            eventData: {},
            weeks: rangeData.weeks,
            firstDay: rangeData.firstDay,
            lastDay: rangeData.lastDay,
        };
    }

    calculateRange() {

        const
            firstMonthDay = this.currentMoment.clone().startOf('month'),
            endDay = this.currentMoment.clone().endOf('month'),
            currentDay = firstMonthDay.clone();

        let weeks = [];
        let lastDay, firstDay;

        for (let i = 0; i <= 5; i++) {
            const startOfWeek = currentDay.clone().startOf('week');
            const endOfWeek = currentDay.clone().endOf('week');

            const range = moment.range(startOfWeek, endOfWeek);

            lastDay = endOfWeek.format('YYYY-MM-DD');
            if (!firstDay) {
                firstDay = startOfWeek.format('YYYY-MM-DD');
            }

            lastDay = endOfWeek.format('YYYY-MM-DD');
            if (!firstDay) {
                firstDay = startOfWeek.format('YYYY-MM-DD');
            }

            weeks.push(range);

            currentDay.add(1, 'w');
        }

        return {
            weeks,
            firstDay,
            lastDay
        };
    }

    loadEvents() {
        this.setState({
            loading: true
        });

        axios.get(`/events/?from=${this.state.firstDay}&to=${this.state.lastDay}`).then((response) => {
            this.setState({
                loading: false,
                eventData: response.data
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount() {
        this.loadEvents();
    }

    renderWeeks() {
        let i = 0;
        return this.state.weeks.reduce((days, week) => {

            const weekDays = [];

            for (let day of week.by('days')) {
                weekDays.push(this.renderDay(day));
            }

            days.push(<div className={style.week} key={'week' + i}>{weekDays}</div>);

            i++;

            return days;
        }, []);
    }

    renderDay(day) {

        let event;

        if (this.state.eventData[day.format('YYYY-MM-DD')]) {
            event = this.state.eventData[day.format('YYYY-MM-DD')];
        }

        const classNames = cx(style.day, {
            [style.otherMonthDate]: this.currentMoment.format('MM') !== day.format('MM'),
            [style.today]: this.todayMoment.format('MM-DD') === day.format('MM-DD'),
            [style.weekend]: day.format('E') === '6' || day.format('E') === '7',
            [style.event]: event,
            [style.noUrl]: event && !event.url,
            [style.noIcon]: event && !event.icon
        });

        if (event) {
            let icon;

            let eventStyle = {};

            if (event.icon) {
                icon = <img className={style.icon} src={event.icon} />;

                eventStyle.backgroundColor = `${event.colorCode}`;
            } else {
                eventStyle.backgroundColor = `#de102e`;
            }

            if (!event.url) {
                event.url = 'javascript:;'
            }

            if (event.event_continues) {
                eventStyle.marginRight = '0';
                eventStyle.borderTopRightRadius = '0';
                eventStyle.borderBottomRightRadius = '0';
            }

            if (event.event_continued) {
                eventStyle.borderTopLeftRadius = '0';
                eventStyle.borderBottomLeftRadius = '0';
            }

            // Second condition is fix for cases where event continues into next week, to avoid layout issues
            if (event.event_continues && day.format('E') !== '7') {
                eventStyle.width = '44px'
            }

            return (<a href={event.url} title={event.title} style={eventStyle} key={day.format('YYYY-MM-DD')} className={classNames}>
                        {icon}
                        <span className={style.dateText}>{day.format('DD')}</span>
                    </a>);
        }

        return (<div key={day.format('YYYY-MM-DD')} className={classNames}>
                    {day.format('DD')}
                </div>);
    }

    _move = (e) => {

       if (e.target.dataset.direction === 'left') {
           this.currentMoment.subtract(1, 'months');
       } else {
           this.currentMoment.add(1, 'months');
       }

       this.setState(this.calculateState(), () => {
           this.loadEvents();
       });

    }

    componentDidUpdate() {
        tippy('.' + style.day, {
            animation: 'fade',
            duration: 200,
            arrow: true
        });
    }

    render() {

        const weekHeader = [];
        const weekStart = this.todayMoment.clone().startOf('week');

        for (let i = 0; i <= 6; i++) {

            const classNames = cx(style.day, style.weekHeaderName, {
               [style.weekendHeader]: i >= 5
            });

            weekHeader.push(<div key={'head' + i} className={classNames}>{weekStart.format('dd')}</div>);
            weekStart.add(1, 'days');
        }

        return (
            <div className={style.calendar}>
                {this.state.loading && <div className={style.loading}><div className="loading-wheel"/></div>}
                <h3 className={style.calendarHeading}>{Exanimo.trans('event_calendar')}</h3>
                <div className={style.monthHeader}>
                    <div data-direction="left" onClick={this._move} style={{backgroundImage: `url(${leftArrow})`}} className={cx(style.arrow, style.leftArrow)}/>
                    {this.currentMoment.format('MMMM')}
                    <div data-direction="right" onClick={this._move} style={{backgroundImage: `url(${rightArrow})`}} className={cx(style.arrow, style.rightArrow)}/>
                </div>
                <div className={style.weekNames}>{weekHeader}</div>
                <div className={style.weekDays}>
                    {this.renderWeeks()}
                </div>
            </div>
        );
    }
}

export default Calendar;